
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"76","height":"76","viewBox":"0 0 76 76","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M74.2917 17.332C75.9167 15.707 75.9167 12.9987 74.2917 11.457L64.5417 1.70703C63 0.0820312 60.2917 0.0820312 58.6667 1.70703L51 9.33203L66.625 24.957L74.2917 17.332ZM0.5 59.8737V75.4987H16.125L62.2083 29.3737L46.5833 13.7487L0.5 59.8737Z","fill":"#0275D8"}})])
          )
        }
      }
    